import React, { useMemo } from 'react';
import clsx from 'clsx';

import CommonCheckbox from '../../../components/common-checkbox/CommonCheckbox';
import TotalScores from './TotalScores';
import LinkScores from './LinkScores';
import HighlightedText from '../../../components/highlighted-text/HighlightedText';

import scss from './MessagesList.module.scss';

function MessageCard({ message, searchStr, onMessageSelect, isSelected }) {
  const {
    message: messageText,
    r1Total,
    r2Total,
    total,
    filteredR1,
    filteredR2,
    filteredTotal,
    filteredAccurateTotal,
  } = message;

  const isClusterActive = useMemo(
    () => filteredAccurateTotal !== null && filteredAccurateTotal !== undefined,
    [filteredAccurateTotal],
  );

  const handleSelectMessage = () => {
    onMessageSelect(message);
  };

  return (
    <div className={clsx(scss.cardWrapper, isClusterActive && scss.cardWrapperBottomPadding)}>
      {onMessageSelect ? <CommonCheckbox checked={isSelected} onChange={handleSelectMessage} /> : null}

      <HighlightedText value={messageText} searchTerm={searchStr} className={scss.messageText} />

      {isClusterActive ? <TotalScores total={total} totalR1={r1Total} totalR2={r2Total} /> : null}

      <LinkScores
        r1={isClusterActive ? filteredR1 : r1Total}
        r2={isClusterActive ? filteredR2 : r2Total}
        total={isClusterActive ? filteredTotal : total}
      />
    </div>
  );
}

export default MessageCard;
